import { paymentMiddleware as middleware } from './paymentMiddleware';
import { paymentSelectors as selectors } from './paymentSelectors';

export const payment = {
  middleware,
  selectors,
};
